import { IPage } from "@/types/AppTypes";
import { httpRequest } from "@/utils/HttpRequest";
import { IScDetail, IScInsert, IScSearch, IScUpdate } from "./scTypes";


class ScService {
    async page(searchVo: IScSearch, config: object = {}) {
        const apiUrl = "/gtm/statistical/customerAnalysis";
        return await httpRequest.post<IPage<IScDetail>>(apiUrl, searchVo, config);
    }
    //导出
    async export(searchVo: IScSearch) {
        const appPageUrl = "/gtm/statistical/customerAnalysis/export";
        return await httpRequest.postFile<boolean>(appPageUrl, searchVo, { timeout: 300000 });
    }

}

export const scService = new ScService();
